






























import Vue from 'vue';
import { Prop, Component, Model, Watch } from 'vue-property-decorator';

/**
 * Helpers
 */
import { getMinDate, getMaxDate, getDateString } from "@/utils/date-helpers";

/**
 * Composant d'éditeur DatePicker.
 */
@Component
export default class DatePickerInput extends Vue {
	/** Propriétés */
	@Prop({ default: 'fr-FR' })
	locale!: string;

	@Prop()
	min!: string;

	@Prop()
	max!: string;

	/** v-model */
	@Model('date-changed')
	date!: string;

	/** Attributs */
	internalDate: string | null = null;

	menu = false;

	/** Méthodes */
	created() {
		this.internalDate = this.date ? getDateString(new Date(Date.parse(this.date))) : null;
	}

	/** Watchers */
	@Watch('internalDate')
	internalTimeChanged() {
		this.$emit('date-changed', this.internalDate);
	}

	@Watch('date')
	dateChanged() {
		this.internalDate = this.date ? getDateString(new Date(Date.parse(this.date))) : null;
	}

	@Watch('min')
	minChanged() {
		if (!this.internalDate) {
			return;
		}
		const dateMin = new Date(Date.parse(this.min));
		const internalDate = new Date(Date.parse(this.internalDate));

		if (getMinDate([dateMin, internalDate]) === internalDate) {
			this.internalDate = getDateString(dateMin);
		}
	}

	@Watch('max')
	maxChanged() {
		if (!this.internalDate) {
			return;
		}

		const dateMax = new Date(Date.parse(this.max));
		const internalDate = new Date(Date.parse(this.internalDate));

		if (getMaxDate([dateMax, internalDate]) === internalDate) {
			this.internalDate = getDateString(dateMax);
		}
	}

	@Watch('menu')
	menuChanged() {
		this.$emit('onOpenChanged', this.menu);
	}
}
